import { GroupClientsVariables } from '@ms/yammer-graphql';
import queryGroup from '@ms/yammer-graphql/dist/operations/queryGroup.graphql';

import { GraphqlApiRequest, ManagedApiLifecycle, getGraphqlApiRequest, managedApiAction } from '../..';
import { normalizeGroup } from '../../normalization/graphql/normalizeGroup';
import { NormalizedGroupEntities } from '../../normalization/types';
import { Group } from '../../state/types';
import { reportError } from '../../telemetry';
import { PromiseThunkAction } from '../../types';

import {
  GroupLoadFulfilledAction,
  GroupLoadPendingAction,
  GroupLoadRejectedAction,
  GroupLoadResponse,
} from './actions.types';
import { getStatusForId } from './selectors';

const loadGroupPending = (groupId: Group['id']): GroupLoadPendingAction => ({
  type: 'GROUP.LOAD_PENDING',
  payload: {
    groupId,
  },
});

const loadGroupFulfilled = (groupId: Group['id'], entities: NormalizedGroupEntities): GroupLoadFulfilledAction => ({
  type: 'GROUP.LOAD_FULFILLED',
  payload: {
    groupId,
    entities,
  },
});

const loadGroupRejected = (groupId: Group['id'], error: unknown): GroupLoadRejectedAction => ({
  type: 'GROUP.LOAD_REJECTED',
  payload: {
    groupId,
    error,
  },
  error: true,
});

type Load = (groupId: Group['id']) => PromiseThunkAction<void>;
export const loadGroup: Load = (groupId) => async (dispatch, getState) => {
  const state = getState();
  const status = getStatusForId(state, groupId);

  if (status !== 'notRequested') {
    return;
  }

  const request: GraphqlApiRequest<GroupClientsVariables> = getGraphqlApiRequest({
    body: {
      operationName: 'GroupClients',
      query: queryGroup,
      variables: {
        groupId,
      },
    },
  });
  const lifecycle: ManagedApiLifecycle<GroupLoadResponse> = {
    pending: () => loadGroupPending(groupId),
    fulfilled: (rawGroup) => loadGroupFulfilled(groupId, normalizeGroup(rawGroup).entities),
    rejected: (error) => loadGroupRejected(groupId, error),
  };
  const action = managedApiAction({ request, lifecycle });

  try {
    await dispatch(action);
  } catch (error) {
    reportError({ error });
  }
};
